/* eslint vars-on-top: 0 */
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _directiveDependencies = [];
const _controllerDependencies = ['$state', '$rootScope', '$scope'];

/**
 * @ngdoc directive
 * @name directives.controller.DeleteAccountController
 *
 * @description
 * edit form for user details controller
 */
class DeleteAccountController {

    constructor($state, $rootScope, $scope) {

        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$scope.deleteAccountVerificationPassed = false;
        this.$scope.brandName = CWCONFIG.partnerConfig.name;

    }

    deleteAccount() {

        Mixpanel.send('ConnectWeb Delete Account Click');

        this.$state.go('root.dashboard.my-account.ltb', {
            ltb: 'delete-account-confirmation',
        });

    }

}

/**
 * @ngdoc directive
 * @name directives.DeleteAccountDirective
 *
 * @description
 * edit form for user details directive
 */
class DeleteAccountDirective {

    constructor() {

        this.template = require('./delete-account.html');
        this.restrict = 'EA';
        this.replace = false;
        this.scope = {};

        _controllerDependencies.push(($state, $rootScope, $scope) =>
            new DeleteAccountController($state, $rootScope, $scope));
        this.controller = _controllerDependencies;
        this.controllerAs = 'deleteAccountCtrl';

    }

}

_directiveDependencies.push(() => new DeleteAccountDirective());


angular.module('directives')
    .directive('deleteAccount', _directiveDependencies);




// WEBPACK FOOTER //
// ./scripts/directives/dashboard/my-account/data-settings/delete-account/delete-account.js